<!--suppress JSUnresolvedReference -->
@if (luser | async; as user) {
  @if (
    user
      | hasEitherPerm
        : [
            "cauth.add_user",
            "core.add_company",
            "core.add_rfidtag",
            "core.add_assetcategory",
            "core.add_asset",
            "core.add_location",
            "core.add_person",
            "core.add_project",
          ]
  ) {
    <div class="top-menu mx-2">
      <tui-hosted-dropdown [tuiDropdownMaxHeight]="700" [content]="umenu">
        <tui-svg [src]="'mat::add'" class="tm-icon"></tui-svg>
      </tui-hosted-dropdown>
    </div>

    <ng-template #umenu>
      <tui-data-list role="menu">
        <tui-opt-group>
          @if (user | hasAllPerms: ["cauth.add_user"]) {
            <a class="m-option" tuiOption (click)="qaUser()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'tuiIconUserLarge'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>User</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.add_company"]) {
            <a class="m-option" tuiOption (click)="qaCompany()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::company'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Company</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.add_rfidtag"]) {
            <a class="m-option" tuiOption (click)="qaRfidTag()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::rfid'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Tag</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.add_assetcategory"]) {
            <a class="m-option" tuiOption (click)="qaCategory()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::categories'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Category</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.add_asset"]) {
            <a class="m-option" tuiOption (click)="qaAsset()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::asset'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Asset</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.add_location"]) {
            <a class="m-option" tuiOption (click)="qaLocation()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::location'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Location</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.add_person"]) {
            <a class="m-option" tuiOption (click)="qaPerson()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::person'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Person</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.add_project"]) {
            <a class="m-option" tuiOption (click)="qaProject()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::project'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Project</div>
              </div>
            </a>
          }
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  }
}
